export default __webpack_public_path__ + "59652c3f3d67aee135ccb95b1996b75c.svg";